import { QueryClient } from '@tanstack/react-query';
import { recommendationsApi } from '@/services/recommendations-api';
import {
  BUILDER_STALE_TIME,
  fetchDiagnoses,
  fetchSigns,
  fetchSuperclinicCodes,
  fetchSymptoms,
} from './useAvailableNodes';

export const prefetchConditionBuilderData = (queryClient: QueryClient) => {
  void Promise.all([
    queryClient.prefetchQuery({
      queryKey: ['builder', 'superclinic-codes'],
      queryFn: fetchSuperclinicCodes,
      staleTime: BUILDER_STALE_TIME,
    }),
    queryClient.prefetchQuery({
      queryKey: ['builder', 'symptoms'],
      queryFn: fetchSymptoms,
      staleTime: BUILDER_STALE_TIME,
    }),
    queryClient.prefetchQuery({
      queryKey: ['builder', 'signs'],
      queryFn: fetchSigns,
      staleTime: BUILDER_STALE_TIME,
    }),
    queryClient.prefetchQuery({
      queryKey: ['builder', 'diagnoses'],
      queryFn: fetchDiagnoses,
      staleTime: BUILDER_STALE_TIME,
    }),
    queryClient.prefetchQuery({
      queryKey: ['recommendations', 'conditions'],
      queryFn: async () => {
        const response = await recommendationsApi.getConditions();
        return response.data;
      },
      staleTime: BUILDER_STALE_TIME,
    }),
  ]);
};
